import "./projectList.css";
import Project from "../project/Project";
import organ from '../../img/organ.png'
import purplle from '../../img/purplle.png'
import zoomcar from '../../img/zoomcar.png'
import github from '../../img/github.png'

const ProjectList = () => {
  return (
    <div className="pl">
      <div className="pl-texts">
        <h1 className="pl-title">Project</h1>
        {/* <p className="pl-desc">
          Lama is a creative portfolio that your work has been waiting for.
          Beautiful homes, stunning portfolio styles & a whole lot more awaits
          inside.
        </p> */}
      </div>
      {/* <div> <h1>Project</h1></div> */}
      <div className="pl-list">
        <Project img={zoomcar} title="Clone of Zoom car website" 
         link="https://github.com/sameel555/zoomCarProj" 
          description="A web application to rent four-wheelers on a monthly and daily basis.
                      This was a collaborative project which was done by me and 2 other members in 6-days."
        tstack="HTML | CSS | Javascript"
        live="https://compassionate-curie-bac97b.netlify.app" />

        <Project img={organ} title="Organ +"  
        link="https://github.com/sameel555/Organ" 
          description="Organ+ is a web application for approved hospitals for registering an organ donner,
         organ seeker, and notify the seeker in case of organ availability.This was a collaborative project which was done by me and 3 other members in 6-days."
        tstack="ReactJS | CSS | JavaScript | NodeJS | MongoDB"
        live="https://organ-plus-harshithcr1357-gmailcom.vercel.app/" />

        <Project img={purplle} title="Clone of Purplle website" 
        link="https://github.com/sameel555/Purplle-final-with-Database" 
          description="This is an online website for buying beauty products based on brands.This was a collaborative project which was done by me and 2 other members in 6-days."
        tstack="HTML | CSS | Javascript |MongoDb | ExpressJS | Node"
        live=" https://frozen-castle-82316.herokuapp.com/" />
      </div>
    </div>
  );
};

export default ProjectList;